/* ContactsView holds all contacts-related stuff */
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import ContactList from '../widgets/contact-list.jsx';

import { updateFavicon } from '../lib/utils.js';

const messages = defineMessages({
  archived_contacts_title: {
    id: "archived_contacts",
    defaultMessage: "Archived contacts ({count})",
    description: "Label for archived chats"
  },
  search_chats_placeholder: {
    id: "search_chats_placeholder",
    defaultMessage: "Search chats",
    description: "Placeholder in the chat-list (roster) filter box"
  }
});

export default class ContactsView extends React.Component {
  constructor(props) {
    super(props);

    this.handleAction = this.handleAction.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleFilterClear = this.handleFilterClear.bind(this);

    this.state = Object.assign({filter: ''}, ContactsView.deriveStateFromProps(props));
  }

  // Client-side substring match over a contact's [key, comment, display name].
  static doFilter(filter, values) {
    if (!filter) { return true; }
    for (let i = 0; i < values.length; i++) {
      if (('' + values[i]).toLowerCase().indexOf(filter) >= 0) { return true; }
    }
    return false;
  }

  handleFilterChange(e) {
    this.setState({filter: e.target.value});
  }

  handleFilterClear(e) {
    e.preventDefault();
    this.setState({filter: ''});
  }

  static deriveStateFromProps(props) {
    const contacts = [];
    let unreadThreads = 0;
    let archivedCount = 0;

    const me = props.tinode.getMeTopic();
    props.chatList.forEach(c => {
      const blocked = c.acs && !c.acs.isJoiner();
      c.pinned = me.pinnedTopicRank(c.topic);

      // Show only blocked contacts only when props.blocked == true.
      if (blocked && props.blocked) {
        contacts.push(c);
      }
      if (blocked || props.blocked) {
        return;
      }

      if (c.private && c.private.arch) {
        if (props.archive) {
          contacts.push(c);
        } else {
          archivedCount ++;
        }
      } else if (!props.archive) {
        contacts.push(c);
        unreadThreads += c.unread > 0 ? 1 : 0;
      }
    });

    contacts.sort((a, b) => {
      const pin = b.pinned - a.pinned;
      return pin != 0 ? pin : (b.touched || 0) - (a.touched || 0);
    });

    if (archivedCount > 0) {
      contacts.push({
        action: 'archive',
        title: messages.archived_contacts_title,
        values: {count: archivedCount}
      });
    }

    return {
      contactList: contacts,
      unreadThreads: unreadThreads
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.chatList != this.props.chatList ||
        prevProps.archive != this.props.archive ||
        prevProps.blocked != this.props.blocked) {
      const newState = ContactsView.deriveStateFromProps(this.props);
      this.setState(newState);
      if (newState.unreadThreads != prevState.unreadThreads) {
        updateFavicon(newState.unreadThreads);
      }
    }
  }

  handleAction(action_ignored) {
    this.props.onShowArchive();
  }

  render() {
    // Roster filter box only on the main list (not archive/blocked panels).
    const showSearch = !this.props.archive && !this.props.blocked;
    const filter = this.state.filter.trim().toLowerCase();
    return (
      <>
        {showSearch ?
          <FormattedMessage id="search_chats_placeholder" defaultMessage="Search chats"
            description="Placeholder in the chat-list (roster) filter box">{
            (ph) => (
              <div className="panel-form">
                <div className="panel-form-row">
                  <i className="material-icons search">search</i>
                  <input className="search" type="text" placeholder={ph}
                    value={this.state.filter} onChange={this.handleFilterChange} />
                  {this.state.filter ?
                    <a href="#" onClick={this.handleFilterClear}><i className="material-icons">highlight_off</i></a>
                    : <span><i className="material-icons">&nbsp;</i></span>}
                </div>
              </div>
            )
          }</FormattedMessage>
          : null}
        <FormattedMessage id="contacts_not_found"
          defaultMessage="You have no chats\n¯∖_(ツ)_/¯"
          description="HTML message shown in ContactList when no contacts are found">{
          (no_contacts) => <ContactList
            tinode={this.props.tinode}
            connected={this.props.connected}
            contacts={this.state.contactList}
            emptyListMessage={no_contacts}
            topicSelected={this.props.topicSelected}
            myUserId={this.props.myUserId}
            showOnline={true}
            showUnread={true}
            filter={filter}
            filterFunc={ContactsView.doFilter}
            onTopicSelected={this.props.onTopicSelected}
            showContextMenu={this.props.showContextMenu}
            onAction={this.handleAction} />
        }</FormattedMessage>
      </>
    );
  }
};
